import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'alertifyjs/build/css/alertify.css';
import 'alertifyjs/build/css/themes/default.css';
import 'daterangepicker/daterangepicker.css';
import 'manage/stylesheets/application.scss';

import 'shared/adminProxyLoginPlatformIdCopy';
import 'shared/adminProxyLoginSwitcher';

import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';

window.Stimulus = Application.start();
const context = require.context('../manage/controllers', true, /\.js$/);
Stimulus.load(definitionsFromContext(context));
